export default __webpack_public_path__ + "static/media/Down_alt2.8ce4d908.svg";